import { urler } from '../../router/router-urler';

const { partner } = urler();
export const partnerUrler = {
    root: partner,
    livOgHelse: `liv-og-helse`,
    kjoretoy: `kjoretoy`,
    hjemOgFritid: `hjem-og-fritid`,
    husOgHytte: `hus-og-hytte`,
    innbo: `innbo`,
    reise: `reise`,
    landbruk: `landbruk`,
    naring: `naring`,
};

export const partnerLinks = Object.entries(partnerUrler).reduce(
    (next, [key, value]) => ({
        ...next,
        [key]: `${partnerUrler.root}/${value}`,
    }),
    {} as typeof partnerUrler,
);
